<template>
  <div class="printer-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="printer-viewer__content">
      <AppMapPointPanelFirstRow
        @edit="edit"
        :title="printer.name"
        :id="printer.id"
        :img="avatarSrc"
        :avatar-size="avatarSize"
        :has-edit="can(PN.PRINTER_UPDATE)"
        :has-preview="hasPreview"
      />
      <table class="table user-view-table m-0">
        <tbody>
          <tr>
            <th>Model:</th>
            <td>{{ printer.model }}</td>
          </tr>
          <tr>
            <th>Asset number:</th>
            <td>{{ printer.asset_num }}</td>
          </tr>
          <tr>
            <th>Note:</th>
            <td class="multiline">{{ printer.description }}</td>
          </tr>
          <tr>
            <th>Department:</th>
            <td>{{ department.name }}</td>
          </tr>
          <tr>
            <th>Install:</th>
            <td v-if="printer.install_url">{{ printer.install_url }}</td>
            <td v-else></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { getAvatarSrc } from '@/utils/Helpers'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'
import { getIconUrl } from '@/components/leaflet/Icon'

export default {
  name: 'PrinterViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({
    PN,
    printerTemp: {}
  }),
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    point: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('printer', ['getPrinter']),
    ...mapGetters('department', ['getDepartment']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Printer')
    },
    printer() {
      return this.getPrinter(this.id) || {}
    },
    department() {
      return this.getDepartment(this.printer.department_id) || {}
    },
    iconSrc() {
      return getIconUrl(this.point.icon_id, this.point.file_updated_at)
    },
    hasPreview() {
      return this.printer.avatar_id
    },
    avatarSize() {
      return this.printer.avatar_id ? '100px' : '50px'
    },
    avatarSrc() {
      return getAvatarSrc(this.printer.avatar_id, this.printer.avatar_updated_at, this.iconSrc)
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.printer-viewer__content {
  padding: 24px;
}
</style>
